import { useTranslation } from "react-i18next";

import { PaymentStatusButton } from "../../../../components/PaymentStatusButton";
import { putCollectionPointRefundThunk } from "../../../../reducers/collectionPointReducer";
import { getCollectionPointIsUpdating } from "../../../../selectors/collectionPoint";
import { BillingRefundReason, IBillingRefund } from "../../../../types/billings";
import { formatCurrency } from "../../../../utils/currency";
import { BillingCardContainer } from "../BillingCardContainer";
import { BillingLabelValue, BillingLabelValueSize } from "../BillingLabelValue";

import styles from "./BillingRefundCard.module.scss";

interface BillingRefundCardProps {
  refund: IBillingRefund;
  isDisabled?: boolean;
}

export const BillingRefundCard = ({ refund, isDisabled = false }: BillingRefundCardProps) => {
  const { t } = useTranslation();
  const isOverpayment = (refund.amount ?? 0) > 0;

  const key = isOverpayment ? "overpayment" : "underpayment";

  return (
    <BillingCardContainer className={styles.container}>
      <div className={styles.leftContainer}>
        <BillingLabelValue
          label={
            refund.reason === BillingRefundReason.Overpayment
              ? t(`collectionPoint.billingRefundCard.refundAmount`)
              : undefined
          }
          customLabel={
            refund.reason === BillingRefundReason.Deactivation ? (
              <div className={styles.deactivatedLabelContainer}>
                <span className={styles.deactivatedCircle}></span>
                <p className={styles.deactivatedLabel}>{t("collectionPoint.billingRefundCard.deactivated")}</p>
              </div>
            ) : undefined
          }
          value={formatCurrency(refund.amount ?? 0)}
          valueSize={BillingLabelValueSize.Large}
        />
        <BillingLabelValue
          label={t(`collectionPoint.billingRefundCard.${key}${refund.paymentDate ? "Text" : "WaitingText"}`)}
        />
      </div>
      <div className={styles.rightContainer}>
        <p>{t(`collectionPoint.billingRefundCard.${key}`)}</p>
        <PaymentStatusButton
          thunk={putCollectionPointRefundThunk}
          payload={{ id: refund.id, isReturned: !refund.paymentDate }}
          translationKey="collectionPoint.billingRefundChangeModal"
          paidAt={refund.paymentDate}
          isPaid={Boolean(refund.paymentDate)}
          isUpdating={getCollectionPointIsUpdating}
          isDisabled={isDisabled}
        />
      </div>
    </BillingCardContainer>
  );
};
